import type { EditorState } from '@codemirror/state';

/** 記法を露出したままにする行の番号（1 始まり）の集合を返す。 */
export function activeLineNumbers(state: EditorState, hasFocus: boolean): Set<number> {
  const lines = new Set<number>();
  if (!hasFocus) return lines;

  for (const range of state.selection.ranges) {
    const first = state.doc.lineAt(range.from).number;
    const last = state.doc.lineAt(range.to).number;
    for (let line = first; line <= last; line++) lines.add(line);
  }

  return lines;
}
